<template>
  <div
    class="align-items-center d-flex flex-fill justify-content-center"
    style="min-height: 60vh"
  >
    <span
      class="spinner-border spinner-border text-primary"
      role="status"
      aria-hidden="true"
    ></span>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({});
</script>
